import React from 'react';
import { TRANSLATIONS } from '../../../constants';
import { useAppSelector, useTranslate } from '../../../hooks/common';
import LoadOperationDataConverter from './LoadOperationDataConverter';
import LoadOperationDataLine from './LoadOperationDataLine';
import Motor from './Motor';

interface ResultProps {
    renderLoadOperationDataLine: boolean;
    renderLoadOperationDataConverter?: boolean;
}

const Result = ({ renderLoadOperationDataLine, renderLoadOperationDataConverter }: ResultProps) => {
    const translate = useTranslate();
    const mesRequest = useAppSelector(state => state.motor.mesRequest);
    const calculationResponse = useAppSelector(state => state.motor.calculationResponse);
    const { isExEbIICType } = mesRequest.commonData;

    return (
        <div className='result-container'>
            <div className='result-data-title'>
                {translate(TRANSLATIONS.result.title)}
            </div>
            {isExEbIICType && <div>{translate(TRANSLATIONS.result.exEbIIC)}</div>}
            <div className='boxes'>
                {calculationResponse && <>
                    {renderLoadOperationDataLine && <LoadOperationDataLine />}
                    {renderLoadOperationDataConverter && <LoadOperationDataConverter />}
                    <div className='motor-data-container'>
                        <Motor />
                    </div>
                </>}
            </div>
        </div>
    );
};

export default Result;
